import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { Checkpoint } from "../types/Check";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetchChecks =
  (authHeader: string, type?: "individual" | "entity") => () => {
    const config: any = {
      headers: { Authorization: authHeader },
    };

    if (type) {
      config.params = { _type: type };
    }

    return axios.get<Checkpoint[]>(
      `${env.verifyServiceUrl}individual/mandate_check/`,
      config
    );
  };

export const useChecks = (type?: "individual" | "entity") => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(
    ["checks_list", type ?? "all"],
    fetchChecks(authHeader, type),
    {
      retry: false,
      onError: (err: any) => {
        if (err.request?.status === 500 || err.request?.status === 503) {
          navigate(ROUTE.SERVER_ERROR);
        }
      },
    }
  );
};
